<template>
    <b-modal
        size="lg"
        v-model="mostrarModal"
        no-close-on-backdrop
        @close="fecharModal()"
        @show="preencher()">
        <div slot="modal-title">
            Ação -
            <b-badge variant="warning">{{ operacao }}</b-badge>
        </div>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <b-row>
            <b-col sm="12" md="12">
                <b-form-group>
                    <label class="required">Nome da Ação</label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            v-model="nomeAcao"
                        ></b-form-input>
                        <b-form-invalid-feedback> O nome é Obrigatório </b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="6" md="6">
                <b-form-group>
                    <label class="required">Unidade</label>
                    <b-input-group>
                        <b-form-select
                            id="codUnidade"
                            v-model="codUnidade"
                            type="text"
                            :options="unidades"
                            value-field="codUnidade"
                            text-field="nome"
                        ></b-form-select>
                        <b-form-invalid-feedback>Unidade é obrigatório</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" md="3">
                <b-form-group>
                    <label class="required">Data de Inicio</label>
                    <b-input-group>
                        <date-picker
                            v-model="dataInicio"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'">
                        </date-picker>
                        <b-form-invalid-feedback>Data de inicio é obrigatória</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="3">
                <b-form-group>
                    <label class="required">Data Final</label>
                    <b-input-group>
                        <date-picker
                            v-model="dataFim"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'">
                        </date-picker>
                        <b-form-invalid-feedback>A data final é obrigatória</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <div slot="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModal()">
                Cancelar
            </b-button>
            <b-button
                variant="primary"
                :disabled="this.$v.$invalid"
                @click.stop="salvar()"
                class="ml-1">
                Salvar
            </b-button>
        </div>
    </b-modal>
</template>

<script>

import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        pleito: Object,
        operacaoProp: String,
        mostrarModal: {
            type: Boolean,
            default: () => false
        },
        erros: {
            type: Array,
            default: () => []
        },
        dataServicos: {
            type: Object
        },
    },

    validations: {
        nomeAcao: {
            required
        },
        codUnidade: {
            required
        },
        dataInicio: {
            required
        },
        dataFim: {
            required
        }
    },

    data() {
        return {
            nomeAcao: '',
            dataInicio: null,
            codUnidade:null,
            dataFim: null,
            unidades: [],
        }
    },

    computed: {
        operacao() {
            if (this.operacaoProp == 'I') {
                return 'INCLUSÃO'
            }
            return 'ATUALIZAÇÃO'
        }
    },

    methods: {
        preencher() {
            this.obterUnidades()
            if (this.operacaoProp == 'A') {
                this.nomeAcao = this.acao.nomeAcao
                this.dataInicio = this.acao.dataInicio
                this.dataFim = this.acao.dataFim
                this.codUnidade = this.acao.vcCodUnidade
            }
        },

        fecharModal() {
            this.$emit('fechar')
            this.resetar()
        },

        resetar(){
            this.nomeAcao = null
            this.codUnidade = null
            this.dataInicio = null
            this.dataFim = null
        },

        obterUnidades(){
            this.$store.dispatch('addRequest')
            this.dataServicos.obterUnidades().then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.unidades = response.data
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                    }
                )
        },

        salvar() {
            let acaoDto = {
                nomeAcao: this.nomeAcao,
                codUnidade: this.codUnidade,
                dataInicio: this.dataInicio,
                dataFim: this.dataFim,
            }
            this.$emit('salvar', acaoDto)
            this.fecharModal()
        },
    },
}
</script>
